import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import ConfigurationTemplatesSynopticTemplatesModalBasicForm from '@/modules/configurationModule/detail/templates/synoptic-templates/components/modal-basic-form/configuration-templates-synoptic-templates-modal-basic-form.vue'
import ConfigurationTemplatesSynopticTemplatesModalStructure from '@/modules/configurationModule/detail/templates/synoptic-templates/components/modal-structure/configuration-templates-synoptic-templates-modal-structure.vue'
import ConfigurationTemplatesSynopticTemplatesModalOntologies from '@/modules/configurationModule/detail/templates/synoptic-templates/components/modal-ontologies/configuration-templates-synoptic-templates-modal-ontologies.vue'
import ConfigurationTemplatesSynopticTemplatesModalExternalDocumentation from '@/modules/configurationModule/detail/templates/synoptic-templates/components/modal-external-documentation/configuration-templates-synoptic-templates-modal-external-documentation.vue'
import {
    initialConfigurationTemplatesSynopticTemplatesModalState,
    ConfigurationTemplatesSynopticTemplatesModalState
} from '@/modules/configurationModule/detail/templates/synoptic-templates/components/modal/configuration-templates-synoptic-templates-modal.model'
import { cloneDeep } from 'lodash'
import {
    ConfigurationSynopticTemplateCreateRequest,
    ConfigurationSynopticTemplatePatchInBatchRequest,
    ConfigurationSynopticTemplateResponse
} from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'
import { defaultSynopticTemplateTreeNodeStructure } from '@/modules/configurationModule/detail/templates/synoptic-templates/components/modal-structure/configuration-templates-synoptic-templates-modal-structure.model'

@Component({
    components: {
        ConfigurationTemplatesSynopticTemplatesModalBasicForm,
        ConfigurationTemplatesSynopticTemplatesModalStructure,
        ConfigurationTemplatesSynopticTemplatesModalOntologies,
        ConfigurationTemplatesSynopticTemplatesModalExternalDocumentation
    }
})
export default class ConfigurationTemplatesSynopticTemplatesModal extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly broadcastChannelPostMessageFunction!: Function

    @Ref() readonly synopticTemplatesModal!: any

    @Emit()
    create(): ConfigurationSynopticTemplateCreateRequest {
        const { title, active, tree } = this.state.synopticTemplate as ConfigurationSynopticTemplateResponse
        return { title, active, tree }
    }

    @Emit()
    update(): ConfigurationSynopticTemplatePatchInBatchRequest {
        const { id, title, active, tree } = this.state.synopticTemplate as ConfigurationSynopticTemplateResponse
        return { id, title, active, tree }
    }

    state: ConfigurationTemplatesSynopticTemplatesModalState

    get updateMode(): boolean {
        return !!this.state.synopticTemplate?.id
    }

    constructor() {
        super()
        this.state = initialConfigurationTemplatesSynopticTemplatesModalState()
    }

    private async _setSynopticTemplate(synopticTemplate: ConfigurationSynopticTemplateResponse): Promise<void> {
        this.state.synopticTemplate = cloneDeep(synopticTemplate)
        if (!synopticTemplate.tree.length) {
            this.state.synopticTemplate.tree = [ defaultSynopticTemplateTreeNodeStructure().data ]
        }
    }

    async show(synopticTemplate?: ConfigurationSynopticTemplateResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationTemplatesSynopticTemplatesModalState()
        if (synopticTemplate) {
            await this._setSynopticTemplate(synopticTemplate)
        }

        this.synopticTemplatesModal.show()
    }

    hide(): void {
        this.synopticTemplatesModal.hide()
    }
}
